import React from "react";
import maatregelenSvg from "../../../../content/images/table/XMLID_3_.svg";
import $ from "jquery";
import * as GC from "../../../common/common";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";
import "./variable/v";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as Common from "./functions/commonFunctions";
import { CONSTS } from "../../../common/const";
import bijlage from "../../../../content/images/bijlage.svg";
class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnList: [],
      columnListPure: [],
      columnOrderIdentification: "",
      columnOrderReference: "",
    };
    window.$catalog_work_resources_context = this
  }
  /*** ---TABLONUN İÇİNE DEĞERLERİ GETİREN FONKSİYON--- ***/
  fillTable(model, page_number) {
    omnimap
      .FillTableAction(
        model,
        page_number,
        window.$catalog_management_units_token
      )
      .then((result) => {
        CallBackFunctions.FillTableCallBack(
          result,
          page_number,
          window.$catalog_work_resources_columnListPure
        );
      });
  }

  /*** ---TABLOYU YENİLEYEN FONKSİYON--- ***/
  reloadData(page_number, ids, short_type, direction, field, active = []) {
    var model;
    if (!short_type) {
      if (ids && ids.length) {
        model = {
          content: [],
          context: [],
          sorting: [],
          definitions: [process.env.REACT_APP_CATALOG_WORK_RESOURCES],
        };
        window.$catalog_work_resources_lastUsedTableFilter = model;
      } else {
        model = {
          content: [],
          definitions: [process.env.REACT_APP_CATALOG_WORK_RESOURCES],
          sorting: [],
        };
        window.$catalog_work_resources_lastUsedTableFilter = model;
      }
    } else if (short_type) {
      if (ids && ids.length) {
        model = {
          content: [],
          context: [],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
          definitions: [process.env.REACT_APP_CATALOG_WORK_RESOURCES],
        };
        window.$catalog_work_resources_lastUsedTableFilter = model;
      } else {
        model = {
          content: [],
          definitions: [process.env.REACT_APP_CATALOG_WORK_RESOURCES],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
        };
        window.$catalog_work_resources_lastUsedTableFilter = model;
      }
    }

    this.fillTable(model, page_number);
    this.fillFilterColumns();
  }
  async clickReload(){
    $("#cover-spin").show(0);
    // $("#spinner").removeAttr("hidden");

    await window.$catalog_work_resources_context.reloadData(1);

    // that.reloadData(1);
  };
  /*** ---TABLOYU YENİLEYEN FONKSİYON--- ***/
  addContentAndFillTable(key, value) {
    var hasRow = $.grep(window.$catalog_work_resources_content, function (v) {
      return v.key === key;
    });
    if (hasRow.length > 0) {
      window.$catalog_work_resources_content = $.grep(
        window.$catalog_work_resources_content,
        function (value) {
          return value !== hasRow[0];
        }
      );
    }

    if (value !== null) {
      var values = [];
      values.push(value);
      var contentModel = {
        and_or: "AND",
        datatype: "STRING",
        key: key,
        values: values,
      };
      window.$catalog_work_resources_content.push(contentModel);
    }

    var model = {
      content: window.$catalog_work_resources_content,
      definitions: [process.env.REACT_APP_CATALOG_WORK_RESOURCES],
    };
    window.$catalog_work_resources_lastUsedTableFilter = model;
    this.fillTable(model, 1);
  }

  /*** ---COMPONENT AÇILIDĞINDA TABLO SÜTUN ARAMA İNPUTLARININ DOLMASINI SAĞLAYAN FONSİYON--- ***/
  fillFilterColumns(key) {
    var model = {
      definitions: [process.env.REACT_APP_CATALOG_WORK_RESOURCES],
    };
    $.each(window.$catalog_work_resources_column_list, function (index, data) {
      if (data.id !== "" && data.filter === true) {
        omnimap
          .FillFilterColumnsAction(
            model,
            data.id,
            window.$catalog_management_units_token
          )
          .then((result) => {
            CallBackFunctions.FillFilterColumnsCallBack(data, result);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  }
  /*** ---TABLOLARIN SÜTÜN ARAMLARININ ANLIK YAPILMASINI SAĞLAYAN FONSİYON--- ***/
  searchFilterColumns(key, searchId) {
    var that = this;
    var model = {
      definitions: [process.env.REACT_APP_CATALOG_WORK_RESOURCES],
    };

    omnimap
      .SearchFilterColumnsAction(
        model,
        key,
        searchId,
        window.$catalog_management_units_token
      )
      .then((result) => {
        CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async componentDidMount() {
    var that = this;

    /***************************************************************************************/
    /**FREE FORMAT */
    var tableHeaderItems;
    var userColumnResult = await omnimap.GetFreeFormatByIdAction(
      CONSTS.USER_ID_STORE
    );
    // userda column sort id'si varmı ?
    if (userColumnResult.meta.total_found == 0) {
      var user = window.localStorage.getItem("accessToken");
      window.$mm_management_units_column_order_users.client_identification =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.code =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.data.users.push({
        user_id: user.identification,
        id_stores: {
          table_column_order: GC.uuidv4(),
        },
      });
      omnimap
        .GetFreeFormatAction(
          "",
          "POST",
          window.$mm_management_units_column_order_users
        )
        .then(() => {
          // GC.sleep(1500).then(() => this.fillTable());
        });
    }
    //userda column sort id'si var sa else geç
    else {
      let result = await omnimap.GetFreeFormatByIdAction(
        CONSTS.COLUMN_ORDER_CATALOG_WORK_RESOURCES
      );

      // bu sayfanın column sort'u var mı?
      if (result.meta.total_found == 0) {
        window.$catalog_work_resources_column_order_post_model.client_identification =
          CONSTS.COLUMN_ORDER_CATALOG_WORK_RESOURCES;
        window.$catalog_work_resources_column_order_post_model.code =
          CONSTS.COLUMN_ORDER_CATALOG_WORK_RESOURCES;

        omnimap
          .GetFreeFormatAction(
            "",
            "POST",
            window.$catalog_work_resources_column_order_post_model
          )
          .then(() => {
            window.location.reload();
          });
      }
      // bu sayfanın column sort'u varsa else'e geç
      else {
        //burada sayfanın column sortları listenelinr ve table th sıralaması yapılır

        let result = await omnimap.GetFreeFormatByIdAction(
          CONSTS.COLUMN_ORDER_CATALOG_WORK_RESOURCES,
          "GET"
        );

        await this.setState({
          columnOrderIdentification: result.data[0].identification,
          columnOrderReference: result.data[0].reference,
        });

        result = await result.data[0].data.table_sorting.find(
          (x) => x.name === "catalog>work-resources"
        );

        tableHeaderItems = await result.column_list.map((item, index) =>
          item === "checkbox" ? (
            <th className="sorting_disabled">
              <span className="checkAll" />
              <span className="checkNone" style={{ display: "none" }} />
            </th>
          ) : item === "active" ? (
            <th className="sorting_disabled" style={{ width: "1%" }}>
              <div id="beheer-short-table">
                <div id="beheer-svg" className="maatregelen-svg"></div>
                <div id="beheer-snowflake" className="snowflake"></div>
              </div>
            </th>
          ) : item === "paperclip" ? (
              <th className="sorting_disabled">
                <img
                    className="icon-table"
                    src={bijlage}
                    width={18}
                    height={18}
                />
              </th>
          ) : (
            <th key={item}>{item}</th>
          )
        );
        await this.setState({
          columnList: tableHeaderItems,
        });
        window.$catalog_work_resources_columnListPure = result;
      }
    }
    /***************************************************************************************/

    ColumnList.forEach(function (item) {
      if (item.name == "catalog>work-resources") {
        window.$catalog_work_resources_column_list = item["column-list"];
      }
    });

    if (window.$catalog_management_units_token == null) {
      window.$catalog_management_units_token = GC.GetToken().then((token) => {
        window.$catalog_management_units_token = token;
        this.reloadData(1);
      });
    } else that.reloadData(1);

    var table = $("#example").DataTable({
      order: [],
      ordering: false,
      orderCellsTop: true,
      fixedHeader: true,
      searching: false,
      paging: false,
      scrollX: true, //"500px",
      scrollCollapse: true,
      scrollY: "calc(100vh - 330px)",
      dom: '<"top"if>t<"bottom"pr><"clear">',
      info: true,
      infoCallback: function (settings, start, end, max, total, pre) {
        return (
          '<span class="select-item"></span>' +
          '<span class="total_right"><span id="total-rows" class="total">' +
          end +
          "</span> geselecteerd </span>"
        );
      },
      language: {
        paginate: {
          previous: "Eerste",
          next: "Laatste",
        },
        select: {
          rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
        },
      },
      columnDefs: [
        {
          targets: 0,
          data: null,
          defaultContent: "",
          orderable: false,
          className: "select-checkbox",
        },
      ],
      select: {
        style: "multi+shift",
        selector: "tr",
      },
      // Disable sorting on the sorting_disabled class
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: ["sorting_disabled"],
        },
      ],
      colReorder: {
        fixedColumnsLeft: 1
      },
      stateSave: true,
      stateSaveCallback: (settings, data) => {
        let result = CallBackFunctions.TableColumnChangeHandler(
          settings,
          data,
          that.state.columnOrderIdentification,
          that.state.columnOrderReference,
          CONSTS.COLUMN_ORDER_CATALOG_WORK_RESOURCES
        );
        window.$catalog_work_resources_columnListPure = result;
      },
    });

    var lastScrollLeft = 0;
    var lastScrollControl = 0.33;
    var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0

    $(".dataTables_scrollBody").scroll(function () {
      var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();
      if (window.$catalog_work_resources_units_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (window.$catalog_work_resources_units_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
        if (window.$catalog_work_resources_units_scroll_change) {
          if (
            $(".dataTables_scrollBody").prop("scrollHeight") -
              $(".dataTables_scrollBody").scrollTop() <=
            $(".dataTables_scrollBody").height() + buffer
          ) {
            if (document.getElementById("tableSide").className !== "d-none") {
              if (
                `/${this.baseURI.split("/")[3]}/${
                  this.baseURI.split("/")[4]
                }` === that.props.location.pathname &&
                window.$catalog_work_resources_table_total_row_count >
                  process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
              ) {
                $("#cover-spin").show(0);
                window.$catalog_work_resources_page_number++;
                that.fillTable(
                  window.$catalog_work_resources_lastUsedTableFilter,
                  window.$catalog_work_resources_page_number
                );
              }
            } else window.$catalog_work_resources_units_scroll_change = true;
          }
        }
      }
    });

    $("#example thead tr").clone(true).appendTo("#example thead");

    $(table.table().header()).addClass("scrollabe-datatable");

    var tes = (document.getElementsByClassName(
      "scrollabe-datatable"
    )[0].parentElement.id = "scrollabe-datatable-id");

    $("#scrollabe-datatable-id thead tr")
      .clone(true)
      .appendTo("#scrollabe-datatable-id thead");

    $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
      var title = $(this).text();
      if (title) {
        var row = $.grep(
          window.$catalog_work_resources_column_list,
          function (v) {
            return String(v.name).toLowerCase() === String(title).toLowerCase();
          }
        );
        var rowId = row[0].id;
        if (row[0].filter == true) {
          $(this).html(
            '<input type="search" class="col-search" id="' + rowId + '" />'
          );
          $("input", this).on("keyup change", function () {
            if (table.column(i).search() !== this.value) {
              table.column(i).search(this.value).draw();
            }
          });
        } else {
          $(this).html("");
        }
      } else if (this.innerHTML.includes("checkAll")) {
        //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
        $(this).html(
          '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
        );
      } else if (this.innerHTML.includes("snowflake")) {
        $(this).html(
          '<div class="refresh"> </div>' +
            /**popup filter1 */
            '<div class="filter-popup">' +
            '  <span class="popuptext" id="beheer-short-table-popup" ></span>' +
            "</div>"
        );
      } else {
        $(this).html("");
      }
    });

    $("#scrollabe-datatable-id thead").on("click", "th", function () {
      var row_index = table.column(this).index();

      if (row_index != undefined) {
        var nRow = $("#scrollabe-datatable-id thead tr")[0];
        if (
          this.childNodes[0].className != "popup threedots" &&
          this.childNodes[0].className != "refresh"
        ) {
          nRow.childNodes.forEach(function (indx) {
            if (indx.cellIndex != row_index) {
              indx.className = "sorting_disabled";
            }
          });

          if (this.className == "sorting_disabled") {
            this.className = "sorting_asc";
            var row;
            $.each(
              window.$catalog_work_resources_column_list,
              function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              }
            );
            that.reloadData(
              1,
              window.$catalog_work_resources_result,
              row.shortType,
              "ASCENDING",
              row.shortField
            );
          } else if (this.className == "sorting_asc") {
            this.className = "sorting_desc";
            var row;
            $.each(
              window.$catalog_work_resources_column_list,
              function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              }
            );
            that.reloadData(
              1,
              window.$catalog_work_resources_result,
              row.shortType,
              "DESCENDING",
              row.shortField
            );
          } else if (this.className == "sorting_desc") {
            this.className = "sorting_asc";
            var row;
            $.each(
              window.$catalog_work_resources_column_list,
              function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              }
            );
            that.reloadData(
              1,
              window.$catalog_work_resources_result,
              row.shortType,
              "ASCENDING",
              row.shortField
            );
          }

          window.$catalog_work_resources_page_number = 1;
        }
      }
    });

    $("#example tbody").on("click", "tr", function () {
      if ($(".checkAll").attr("style") == "display: none;") {
        $(".checkNone, .checkAll").toggle();
      }
    });

    //** select all table
    $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
      var table = $("#example").DataTable();
      table.rows().select();

      $(".checkNone, .checkAll").toggle();
    });

    //** unselect all table
    $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
      var table = $("#example").DataTable();

      table.rows().deselect();
      $(".checkNone, .checkAll").toggle();
    });

    $("#example_filter input").addClass("search-input-table1");
    $(".search-input-table1").attr("placeholder", "search text");
    $("#example tbody").on("dblclick", "tr", function () {
      // var rowId = this.attributes[1].value;
      var id_rowId = this.attributes[2].nodeValue;
      var rowId = $(this).attr("rowId");

      $.each(window.$catalog_work_resources_Glist, function (index, data) {
        if (data.identification == rowId) {
          window.$catalog_work_resources_selectedRow = data;
        }
      });
      window.$catalog_work_resources_row_id = id_rowId;
      Common.GetRowOfDetail(rowId);

      $("#tableSide").addClass("d-none");
      $("#detailSide").removeClass("d-none");
    });
    /** OPTİON TO ALLOW SELECTİNG ROWS BY CLİCKİNG ON ROW BESİDES CHECKBOX ***/
    // $("#example tbody").on("click", "tr", function () {
    //   $(this).toggleClass("selected");
    // });
    $(".col-search").on("input", function (e) {
      if (this.value === "") {
        that.addContentAndFillTable($(this).attr("id"), null);
      }
    });
    table.columns().iterator("column", function (ctx, idx) {
      if (
        window.$catalog_work_resources_columnListPure.column_list[idx] ===
          "checkbox" ||
        window.$catalog_work_resources_columnListPure.column_list[idx] ===
          "active"
      ) {
      } else {
        $(table.column(idx).header()).append('<span class="sort-icon"/>');
      }
    });
    $(document).on("click", ".catalog-work-resources-action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$catalog_work_resources_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });

    $(document).on("click", "#work-resource-verwijderen", function () {
      if (window.$catalog_work_resources_selectedIds == 0) {
        alert("rows not selected");
      } else {
        $("#work-resource-mappen_beheren_delete_modal").modal("show");
      }
    });

    // that.reloadData(1);

    $("#work-resource-rows-delete-modal").click(function () {
      window.$catalog_work_resources_selectedIds.forEach((element) =>
        omnimap
          .Delete(element, window.$catalog_management_units_token)
          .then(() =>
            CallBackFunctions.RowsDeletedCallBack(
              window.$catalog_management_units_token
            )
          )
      );
    });
    function handleRefresh () {
      $("#cover-spin").show(0);
      $("#spinner").removeAttr("hidden");
      that.reloadData(1);
    }
    window.$catalog_work_resources_refresh = handleRefresh;

    $(".refresh").click(handleRefresh);

    $(".back-page-link").click(function () {
      $("#tableSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
      $("#editSide").addClass("d-none");
    });
    $("#edit-button").click(function () {
      $("#editSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
      Common.GetColumnProperties("edit");
    });
    $("#return-detail").click(function () {
      $("#detailSide").removeClass("d-none");
      $("#editSide").addClass("d-none");
    });

    $("div.popup").click(function () {
      var selectedIds = [];
      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      window.$catalog_work_resources_selectedIds = selectedIds;

      GetActionsOfRow(selectedIds.join(","));
    });
    /*** başlangıç tarihi değiştiğinde, bitiş tarihinin başlangıç tarihinden küçük olmamasını control eder */
    $("#e-startDate").change(function () {
      if (this.value > $("#e-endDate").val()) {
        $("#e-endDate").val(this.value);
      }
      $("#e-endDate").attr("min", this.value);
    });

    //#region Autocomplete Functions
    $("#algemeen-naam").autocomplete({
      source: window.$catalog_work_resources_algemeenNaam,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-naam", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-code").autocomplete({
      source: window.$catalog_work_resources_algemeenCode,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-code", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });

    $("#algemeen-kosteneenheid").autocomplete({
      source: window.$catalog_work_resources_algemeenKosteneenheid,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-kosteneenheid", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-omschrijving").autocomplete({
      source: window.$catalog_work_resources_algemeenOmschrijving,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-omschrijving", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-type").autocomplete({
      source: window.$catalog_work_resources_algemeenOmschrijving,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-type", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-prijs").autocomplete({
      source: window.$catalog_work_resources_algemeenPrijs,
      select: function (event, ui) {
        that.addContentAndFillTable("algemeen-prijs", ui.item.value);
      },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#algemeen-naam").on("input", function () {
      // that.algemeenNaam.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-code").on("input", function () {
      // that.algemeenCode.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-kosteneenheid").on("input", function () {
      // that.algemeenKosteneenheid.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });

    $("#algemeen-omschrijving").on("input", function () {
      // that.algemeenOmschrijving.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-type").on("input", function () {
      // that.algemeenOmschrijving.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#algemeen-prijs").on("input", function () {
      // that.algemeenOmschrijving.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    //#endregion

    function GetActionsOfRow(rowIds) {
      omnimap
        .GetActionsOfRowAction(rowIds, window.$catalog_management_units_token)
        .then(CallBackFunctions.GetActionsOfRowCallback)
        .catch((error) => {
          console.log(error);
        });
    }
  }

  render() {
    return (
      <div id="tableSide">
        <table id="example" className="table-hover table min-full-width">
          <thead>
            <tr>
              {this.state.columnList}
              {/* <th className="sorting_disabled">
                <span className="checkAll" />
                <span className="checkNone" style={{ display: "none" }} />
              </th>
              <th className="sorting_disabled">
                <img
                  className="icon-table"
                  src={maatregelenSvg}
                  width={18}
                  height={18}
                />
              </th>
              <th>Naam</th>
              <th>Code</th>
              <th>Omschrijving</th>
              <th>Type</th>
              <th>Prijs</th>
              <th>Kosteneenheid</th>
              <th>Datum aangemaakt</th>
              <th>Datum laatst gewijzigd</th> */}
            </tr>
          </thead>
          <tbody></tbody>
        </table>
        <input id="tree-parent-id" hidden />
      </div>
    );
  }
}

export default Table;
